import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import LeaderboardView from '@/components/Leaderboard';

interface LeaderboardPageProps {
  onNavigate: (page: 'home') => void;
}

export default function LeaderboardPage({ onNavigate }: LeaderboardPageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* 顶部导航 */}
      <nav className="p-4 flex items-center gap-4">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onNavigate('home')}
          className="text-white hover:bg-slate-800"
        >
          <ArrowLeft className="w-6 h-6" />
        </Button>
        <h1 className="text-xl font-bold text-white">排行榜</h1>
      </nav>

      {/* 主内容 */}
      <main className="container mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl mx-auto"
        >
          <LeaderboardView />
        </motion.div>
      </main>
    </div>
  );
}
